/**
 * Design tokens measured from the live artome.fi site.
 *
 * `theme.ts` is derived from these. Raw values live here because a few places
 * need CSS strings rather than theme lookups (CSS masks, `env()` insets,
 * `MuiCssBaseline`).
 */
export const tokens = {
  color: {
    /** Brand accent. Same value the marketing site uses for emphasis. */
    amber: "#ECAA1D",
    amberHover: "#D89A15",
    /** Headings and primary ink. */
    ink: "#1C1B1F",
    /** Body copy. */
    body: "#333333",
    /** Secondary/supporting text. */
    muted: "#49454F",
    hairline: "#EBEBEB",
    pageBg: "#F4F4F4",
    surface: "#FFFFFF",
    disabled: "#A4A4A4",
  },
  radius: {
    pill: 999,
    card: 16,
    input: 12,
    base: 8,
  },
  space: {
    cardPadding: 24,
    containerMax: 1280,
  },
  shadow: {
    md: "rgba(14,14,16,0.12) 0 2px 8px",
  },
  font: {
    family: `'Nunito Sans', system-ui, -apple-system, 'Segoe UI', Roboto, sans-serif`,
  },
} as const;

export default tokens;
